module.exports = __webpack_public_path__ + "img/68.2bf8cdb8.svg";